export default "__VITE_ASSET__ACVro7pR__"